<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiStarShootingOutline } from '@mdi/js'

export default {
  name: 'IconProduct',
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiStarShootingOutline
    }
  }
}
</script>
